import React from "react";

import {
  FundraiserResponse,
  FundraiserFeedResponse,
} from "@every.org/common/src/codecs/entities";

/**
 * Input type for adding fundraisers - accepts either full or light response.
 */
export type FundraiserInput = FundraiserResponse | FundraiserFeedResponse;

/**
 * ContextFundraiser is the stored type, extending FundraiserResponse.
 * Feed responses (FundraiserFeedResponse) are cast in the reducer - merging
 * ensures missing fields are preserved from existing data when present.
 */
export type ContextFundraiser = FundraiserResponse;

/**
 * Status of a tag being searched for
 */
export enum FundraiserFetchStatus {
  FOUND = "FOUND",
  FETCHING_FUNDRAISER = "FETCHING_FUNDRAISER",
  FUNDRAISER_NOT_FOUND = "FUNDRAISER_NOT_FOUND",
}

export type FundraiserOrFetchStatus =
  | ContextFundraiser
  | Exclude<FundraiserFetchStatus, FundraiserFetchStatus.FOUND>;

/**
 * Current state in browser memory of fetched fundraisers
 */
export interface FundraisersState {
  dispatchFundraiserAction: React.Dispatch<FundraiserAction>;
  fundraisersById: Map<ContextFundraiser["id"], ContextFundraiser>;
  fundraiserFetchStatus: Map<ContextFundraiser["id"], FundraiserFetchStatus>;
}
export type InternalFundraisersState = Omit<
  FundraisersState,
  "dispatchFundraiserAction"
>;

export type FundraiserIdentifier = { id: ContextFundraiser["id"] };

export enum FundraiserActionType {
  FETCHING_FUNDRAISER = "FETCHING_TAG",
  ADD_FUNDRAISER = "ADD_FUNDRAISER",
  ADD_FUNDRAISERS = "ADD_FUNDRAISERS",
  FUNDRAISER_NOT_FOUND = "FUNDRAISER_NOT_FOUND",
}
interface FetchingFundraiserAction {
  type: FundraiserActionType.FETCHING_FUNDRAISER;
  data: FundraiserIdentifier;
}
interface AddFundraiserAction {
  type: FundraiserActionType.ADD_FUNDRAISER;
  data: FundraiserInput;
}
interface AddFundraisersAction {
  type: FundraiserActionType.ADD_FUNDRAISERS;
  data: FundraiserInput[];
}
interface FundraiserNotFoundAction {
  type: FundraiserActionType.FUNDRAISER_NOT_FOUND;
  data: FundraiserIdentifier;
}
export type FundraiserAction =
  | AddFundraiserAction
  | AddFundraisersAction
  | FetchingFundraiserAction
  | FundraiserNotFoundAction;
